/* -----------------Child components--------------- */
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";

import { appBarMeta } from "@constants/appbar";
import { events, pageViewTypes } from "@constants/tracking";
/* -----------------Features--------------- */
import LeaderboardContainer from "@features/dashboard/screens/LeaderboardContainer";
import useAnalytics from "@hooks/useAnalytics";
import { trackCustomEvent } from "analytics";
import DocumentTitle from "components/DocumentTitle";
import { useNavigation } from "expo-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const LeaderboardRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.leaderboard,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	const { t } = useTranslation();
	const navigation = useNavigation<{ toggleDrawer?: () => void }>();
	return (
		<>
			<DocumentTitle title="Leaderboard" />
			<CustomAppBar
				title={t(appBarMeta.leaderboard.title)}
				navigation={navigation}
				handleTrackEvent={() => {
					trackCustomEvent({
						eventName: events.commandBarClicked,
						option: "command_bar",
					});
				}}
			/>
			<LeaderboardContainer />
		</>
	);
};

export default LeaderboardRoute;
